import { Accepts, Types, OutletType } from "@citychallenge/common";
import { Inlet, Outlet } from "../../reactive";
import { defineElement } from "../define-element";

export class QuestionProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];

  @Inlet(Accepts.MarkdownText) public introduction!: Types["MarkdownText"];
  @Inlet(Accepts.Text) public question!: Types["Text"];
  @Inlet(Accepts.TextList) public answers!: Types["TextList"];

  @Inlet(Accepts.Hints) public hints?: Types["Hints"];

  /* Deprecated */
  @Inlet(Accepts.MarkdownText) public answerExplained?: Types["MarkdownText"];

  @Outlet() public onQuestionCorrect!: OutletType;
  @Outlet() public onQuestionIncorrect!: OutletType;
}

export const QuestionDefinition = defineElement("question", QuestionProps, {
  versionRequired: "0.8.0",
});
